import { render, staticRenderFns } from "./AdditionalSetup.vue?vue&type=template&id=7562b60b&scoped=true"
import script from "./AdditionalSetup.vue?vue&type=script&lang=js"
export * from "./AdditionalSetup.vue?vue&type=script&lang=js"
import style0 from "./AdditionalSetup.vue?vue&type=style&index=0&id=7562b60b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562b60b",
  null
  
)

export default component.exports